import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { BsButton } from '../../collection/bootstrap/BootstrapComponents';
import DataTable from '../../collection/DataTable';
import BoolIcon from '../../collection/icons/Boolean';
import TableHandler from '../../collection/TableHandler';
import FloatingAddButton from '../../components/project/FloatingAddButton';
import { apiDelete, apiForm } from '../../utils/api';
import { sortableString, generateFormData } from '../../utils/functions';
import UsuariosFilter from '../../components/filters/UsuariosFilter';

export default function Usuarios(props) {
    // filter
    const defaultFilter = {
        nombre: null,
        apellidos: null,
        departamentos: null,
        localidadId: null,
        convenioId: null
    };
    let filter = generateFormData(defaultFilter);
    // api calls
    const updateData = async newFilter => {
        filter = newFilter ? newFilter : filter;
        return await apiForm("usuarios/table", filter);
    };
    const deleteRow = async id => await apiDelete("usuarios/delete/" + id);

    // render
    return <>
        <h2>Usuarios</h2>
        <TableHandler
            onUpdate={updateData}
            onDelete={deleteRow}
            elementText="el usuario">
            <UsuariosFilter
                className="my-3" fem
                defaultValue={defaultFilter}
                selectDepartamento
                selectLocalidad
                selectConvenio />
            <UsuariosTable className="mt-3"/>
        </TableHandler>
    </>;
}

function UsuariosTable(props) {
    // table columns
    const columns = [
        {
            name: "Nombre",
            selector: row => sortableString(row.Name),
            format: row => row.Name,
            sortable: true,
            width: "14%"
        },
        {
            name: "Apellidos",
            selector: row => sortableString(row.Apellidos),
            format: row => row.Apellidos,
            sortable: true,
            width: "16%"
        },
        {
            name: "Departamento",
            selector: row => sortableString(row.NombreDepartamento),
            format: row => row.NombreDepartamento,
            sortable: true
        },
        {
            name: "Localidad",
            selector: row => sortableString(row.Localidad),
            format: row => row.Localidad,
            sortable: true,
            width: "10%"
        },
        {
            name: "Admin",
            selector: row => row.PermisoAdmin,
            format: row => <BoolIcon value={row.PermisoAdmin} size="lg" />,
            sortable: true,
            center: true,
            width: "8%"
        },
        {
            name: "Vest.",
            selector: row => row.PermisoVestuario,
            format: row => <BoolIcon value={row.PermisoVestuario} size="lg" />,
            sortable: true,
            center: true,
            width: "8%"
        },
        {
            name: "Activo",
            selector: row => row.Activo,
            format: row => <BoolIcon value={row.Activo} size="lg" />,
            sortable: true,
            center: true,
            width: "8%"
        },
        {
            name: "Es Oficina?",
            selector: row => row.EsOficina,
            format: row => <BoolIcon value={row.EsOficina} size="lg" />,
            sortable: true,
            center: true,
            width: "8%"
        }
    ];
    // table buttons
    const buttons = <>
        <BsButton variant="secondary" size="sm" onClick={props.onEdit}><FontAwesomeIcon icon={faEdit} /></BsButton>
        <BsButton variant="danger" size="sm" onClick={props.onDelete}><FontAwesomeIcon icon={faTrash} /></BsButton>
    </>;

    // navigate
    const navigate = () => {
        const path = props.formId ? "editar/" + props.formId : "nuevo";
        return (<Navigate to={path} />);
    }

    // render
    return <>
        <DataTable responsive rowname="NombreCompleto" columns={columns} data={props.data} buttons={buttons} pagination />
        {props.formOpen && navigate()}
        <FloatingAddButton onClick={props.onNew} />
    </>;
}
